import { useForm } from '@mantine/form';
import { ProposalCreationClientAndMortgageForm } from '../types';

export namespace ProposalFormHandlers {
  export const propertyStatusHandler = <T extends any>(
    form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
    value: T) => {
    form.getInputProps('property_details.property_status').onChange(value);
  };
  export const existingMortgageTypeHandler = <T extends any>(
    form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
    value: T) => {
    form.getInputProps('mortgage_details.existing_mortgage_type').onChange(value);
  };
  export const transactionTypeHandler = <T extends any>(
    form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
    value: T) => {
    form.getInputProps('mortgage_details.transaction_type').onChange(value);
  };
  export const realEstateFeeFinanceHandler = <T extends any>(
    form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
    value: T) => {
    form.getInputProps('mortgage_details.is_real_estate_fee_financed').onChange(value);
  };
  export const landDepartmentFeeFinanceHandler = <T extends any>(
    form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
    value: T) => {
    form.getInputProps('mortgage_details.is_land_department_fee_financed').onChange(value);
  };
  export const propertyLocationHandler = <T extends any>(
    form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
    value: T) => {
    form.getInputProps('property_details.property_location').onChange(value);
  };
  export const isDIFCHandler = <T extends any>(
    form: ReturnType<typeof useForm<ProposalCreationClientAndMortgageForm>>,
    value: T) => {
    form.getInputProps('property_details.is_difc').onChange(value);
  };
}
